<template>
  <div class="foot_tab p_f d_f ali_c j_s">
    <div
      class="tab_item t_a"
      @click="$router.push('/')"
    >
      <img
        src="../assets/img/m_1.png"
        alt=""
      >
      <div>首页</div>
    </div>
    <div
      class="tab_item t_a"
      :class="ac == 2 ? 'ac' : ''"
      @click="$router.push('/around')"
    >
      <img
        v-if="ac == 2"
        src="../assets/img/m_2a.png"
        alt=""
      >
      <img
        v-else
        src="../assets/img/m_2.png"
        alt=""
      >
      <div>周边</div>
    </div>
    <div
      class="tab_item t_a"
      :class="ac == 3 ? 'ac' : ''"
      @click="$router.push('/destination')"
    >
      <img
        v-if="ac == 3"
        src="../assets/img/m_3a.png"
        alt=""
      >
      <img
        v-else
        src="../assets/img/m_3.png"
        alt=""
      >
      <div>目的地</div>
    </div>
    <div
      class="tab_item t_a"
      :class="ac == 4 ? 'ac' : ''"
      @click="$router.push('/service')"
    >
      <img
        v-if="ac == 4"
        src="../assets/img/m_4a.png"
        alt=""
      >
      <img
        v-else
        src="../assets/img/m_4.png"
        alt=""
      >
      <div>服务</div>
    </div>
    <div
      class="tab_item t_a"
      :class="ac == 5 ? 'ac' : ''"
      @click="$router.push('/mine')"
    >
      <img
        v-if="ac == 5"
        src="../assets/img/m_5a.png"
        alt=""
      >
      <img
        v-else
        src="../assets/img/m_5.png"
        alt=""
      >
      <div>我的</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "FootTab",
    props:{
      ac:{//标题
        type:Number,
        default:1
      },
    },
    data() {
      return {}
    },
    methods: {}
  }
</script>

<style scoped lang="scss">
  .foot_tab{
    .tab_item{
      font-size: 22px;
      font-weight: 500;
      color: #B0B0B0;
      img{
        height: 49px;
        margin-bottom: 15px;
      }
      &.ac{
        color: #4087F5;
      }
    }
    box-sizing: border-box;
    font-size: 0;
    height: 140px;
    background: #FFFFFF;
    width: 100%;
    left: 0;
    bottom: 0;
    padding: 27px 38px 24px;
    border-top: 1px solid #ECECEC;
    z-index: 999;
  }
</style>
